module.exports = __webpack_public_path__ + "static/img/2.e1590fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/2.png
// module id = juam
// module chunks = 0